import { useEffect } from "react";
import { buildTheme } from "../utils/theme";

export let T = {};

export function useThemeObject(theme) {
  T = buildTheme(theme.bg, theme.accent);
  return T;
}

export const FontLoader = () => {
  useEffect(() => {
    const l = document.createElement("link");
    l.href =
      "https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@500;700;800;900&family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600;1,9..40,300&family=Orbitron:wght@600;700;800;900&display=swap";
    l.rel = "stylesheet";
    document.head.appendChild(l);
  }, []);
  return null;
};

export const GlobalStyles = ({ theme }) => {
  T = buildTheme(theme.bg, theme.accent);
  return (
    <style>{`
    :root{
      --lov-section-warmup:142 71% 45%;
      --lov-section-strength:217 91% 60%;
      --lov-section-cardio:25 95% 53%;
      --lov-section-finisher:271 91% 65%;
      --lov-section-cooldown:0 0% 40%;
      --block-warmup:#34D399;
      --block-strength:#60A5FA;
      --block-hypertrophy:#F87171;
      --block-metabolic:#FBBF24;
      --block-core:#A78BFA;
      --block-finisher:#A78BFA;
      --block-cooldown:#9CA3AF;
      --block-custom:#B8FF47;
    }
    *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
    html,body{background:${T.bg};color:${T.text};font-family:'DM Sans',sans-serif;-webkit-font-smoothing:antialiased;overflow:hidden;height:100%}
    ::-webkit-scrollbar{width:4px}::-webkit-scrollbar-track{background:transparent}::-webkit-scrollbar-thumb{background:${T.border};border-radius:2px}
    input,textarea,select{outline:none;font-family:inherit}
    button{cursor:pointer;font-family:inherit;border:none;background:none;outline:none}
    button:focus-visible,a:focus-visible,input:focus-visible,textarea:focus-visible,select:focus-visible,[tabindex]:focus-visible{outline:2px solid ${T.accent};outline-offset:2px;border-radius:4px}
    .skip-link:focus{left:50%!important;transform:translateX(-50%);width:auto!important;height:auto!important;overflow:visible!important;clip:auto!important}
    .hide-scrollbar::-webkit-scrollbar{display:none}
    @keyframes fadeIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}
    @keyframes spin{to{transform:rotate(360deg)}}
    @keyframes micWave{0%,100%{transform:scaleY(1)}50%{transform:scaleY(2.4)}}
    @keyframes slideRight{from{opacity:0;transform:translateX(-10px)}to{opacity:1;transform:translateX(0)}}
    @keyframes glowPulse{0%{box-shadow:0 0 0 ${T.accent}00}50%{box-shadow:0 0 60px ${T.accent}59}100%{box-shadow:0 0 0 ${T.accent}00}}
    @keyframes floatLogo{0%,100%{transform:translateY(0)}50%{transform:translateY(-6px)}}
    @keyframes shapeRoam1{0%{transform:translate(0,0)}25%{transform:translate(6px,-5px)}50%{transform:translate(3px,-8px)}75%{transform:translate(-2px,-3px)}100%{transform:translate(0,0)}}
    @keyframes shapeRoam2{0%{transform:translate(0,0)}25%{transform:translate(-7px,-3px)}50%{transform:translate(-5px,-9px)}75%{transform:translate(2px,-5px)}100%{transform:translate(0,0)}}
    @keyframes shapeRoam3{0%{transform:translate(0,0)}25%{transform:translate(5px,4px)}50%{transform:translate(8px,-2px)}75%{transform:translate(3px,6px)}100%{transform:translate(0,0)}}
    @keyframes softPulse{0%,100%{opacity:.82;transform:scale(1)}50%{opacity:1;transform:scale(1.04)}}
    @keyframes sessionSweep{0%{left:-30%;opacity:0}8%{opacity:1}92%{opacity:1}100%{left:100%;opacity:0}}
    @keyframes nudgePulse{0%,100%{box-shadow:0 0 0 0 ${T.accent}66}50%{box-shadow:0 0 16px 4px ${T.accent}40}}
    @keyframes borderSweep{0%{background-position:200% 0}100%{background-position:-200% 0}}
    @keyframes sweepVertical{0%{top:-30%;opacity:0}8%{opacity:1}92%{opacity:1}100%{top:100%;opacity:0}}
    @keyframes sweepRotate{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
    @media(prefers-reduced-motion:reduce){*{animation-duration:0s!important;animation:none!important}}
    .fade-in{animation:fadeIn .3s ease forwards}
    .condensed{font-family:'Barlow Condensed',sans-serif}
    .slide-in{animation:slideRight .25s ease forwards}
    .stat-card{transition:transform .2s ease,box-shadow .2s ease,border-color .25s ease}
    .stat-card:hover{transform:translateY(-3px);box-shadow:0 12px 32px ${T.isLight ? "rgba(0,0,0,.1)" : "rgba(0,0,0,.5)"};border-color:${T.accent}40!important}
    .client-row{transition:background .15s ease}
    .client-row:hover{background:${T.surface2}!important}
    .workout-card-library{position:relative}
    .workout-card-library .workout-card-menu-btn{opacity:0;transition:opacity .15s ease}
    .workout-card-library:hover .workout-card-menu-btn{opacity:1}
    .nav-btn{transition:background .15s ease,color .15s ease,border-color .15s ease,transform .1s ease}
    .nav-btn:hover{transform:scale(1.08)}
    .accent-btn{transition:opacity .15s ease,transform .1s ease}
    .accent-btn:hover{opacity:.88;transform:scale(1.02)}
    .accent-btn:active{transform:scale(.97)}
    @media(max-width:640px){
      body{overflow:auto}
      .desktop-sidebar{display:none!important}
      .mobile-nav{display:flex!important}
      .main-content{padding:14px!important}
      .stats-grid{grid-template-columns:1fr 1fr!important}
      .clients-grid{grid-template-columns:1fr!important}
      .session-grid{grid-template-columns:1fr!important}
      .profile-grid{grid-template-columns:1fr!important}
      .billing-table-header,.billing-table-row{grid-template-columns:1.5fr 60px 80px 80px!important}
      .billing-col-urssaf,.billing-col-status{display:none!important}
      .week-grid{grid-template-columns:repeat(4,1fr)!important}
      .profile-header-actions{flex-wrap:wrap!important;gap:8px!important}
      h1.condensed{font-size:28px!important}
    }
    @media(max-width:400px){
      .stats-grid{grid-template-columns:1fr!important}
    }
  `}</style>
  );
};
